import {AxiosInstance} from 'axios';

export interface Description {
    details: string;
}

export interface ConsentPayload {
    full_name: string;
    company: string;
    phone_number: string;
    email: string;
    description: Description;
    address: string;
    consentFormId: number;
}

export interface ConsentForm {
  data: ConsentPayload | null;
}

export class Consent {
  private readonly instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  public submitForm(payload: ConsentPayload): Promise<ConsentForm> {
    const URL = `/consent_request`;
    return new Promise((resolve, reject) => {
      // reject if token is empty
      if (!payload) {
        reject({
          code: 'EMPTY_CONSENT_PAYLOAD',
          message: 'Form can not be empty'
        });
        return;
      }
      this.instance.post(URL, payload)
        .then((res: any) => {
        if (res.data.length === 0) {
            resolve({
              data: null,
            });
            return;
          }
        resolve({
          data: res.data[0],
          });
        })
        .catch((err) => {
          resolve({
            data: null,
          });
        });
    });
  }
}
